<app-header [title]="title" [subtitle]="subtitle"></app-header>

<main class="palettes-info">
    <article class="containero">
      <div class="zoomin">
        <img class="zoomin" src="assets/foto2.jpg" />
        <div class="k-800  "><div class="info align-self-center">dostępne prawie<span>800</span>wariantów<br/>kolorystycznych</div></div>
      </div>
        <p class="first"  >
            Wędrówkę po kolorach i ich wybór na elewację, ułatwi Ci 5 palet
            kolorystycznych – <b>Top Design</b>, <b>Miejski szyk</b>, <b>Światowe inspiracje</b>, <b>Klasyczna elegancja</b>,
            <b>W&nbsp;zgodzie z naturą</b>. Palety są wskazówką, jakie połączenia
            kolorystyczne najlepiej wyglądają na elewacji. Stworzyliśmy je w
            oparciu o architekturę domów, ich lokalizację, styl życia i&nbsp;upodobania
            inwestorów oraz kolory tynków Knauf Classic i&nbsp;Knauf Finess.
        </p>
        <h3  ><b>Każda paleta zawiera</b>:</h3>

        <div class="color-info row">
            <div class="first col"><span>30</span> <em  >kolorów<br/>podstawowych</em></div>
            <div class="col"><span>15</span> <em  >kolorów<br/>uzupełniających</em></div>
            <div class="col"><span>5</span> <em  >akcentów<br/>kolorystycznych</em></div>
        </div>

        <h3  >JAK KORZYSTAĆ Z PALET KOLORYSTYCZNYCH?</h3>
        <p  >
            Bardzo dobry efekt osiągniesz stosując na dużych powierzchniach
            jeden z kolorów podstawowych. Ten kolor potraktuj jako dominantę,
            która zajmie największą część elewacji. Na mniejszych powierzchniach
            uzupełnij go kolorem dodatkowym. Akcenty kolorystyczne
            wybierz do podkreślenia niewielkich elementów na elewacji.

        </p>

    </article>
</main>

<app-footer [next]="next"></app-footer>
